<template>
  <div>
    <div class="search flex">
      <span class="tit">操作日志</span>
      <div>
        <el-checkbox @change="changeCondition" v-model="eventCondition.remark"
                     :disabled="eventCondition.eventType !== 'event_article'">文章历史
        </el-checkbox>

        <el-input placeholder="请输入名称/手机号/邮箱" class="addART" v-model="eventCondition.eventId"
                  suffix-icon="el-icon-search"
                  size="small"
                  @change="changeCondition"></el-input>
      </div>
    </div>
    <div>
      <el-radio-group
          v-model="eventCondition.eventType"
          size="small"
          class="radioGroup"
          @change="changeCondition">
        <!--<el-radio-button label="all">所有</el-radio-button>-->
        <el-radio-button label="event_user"
                         :disabled="eventCondition.operateCode === 'pass'||eventCondition.operateCode === 'reject'||eventCondition.operateCode === 'cancel'">
          用户
        </el-radio-button>
        <el-radio-button label="event_doctor" :disabled="eventCondition.operateCode === 'cancel'">
          医生
        </el-radio-button>
        <el-radio-button label="event_article"
                         :disabled="eventCondition.operateCode === 'cancel'||eventCondition.operateCode === 'reset_pwd'">
          文章
        </el-radio-button>
        <el-radio-button label="event_appoint"
                         :disabled="eventCondition.operateCode === 'ban'||eventCondition.operateCode === 'un_ban'||eventCondition.operateCode === 'reset_pwd'">
          预约
        </el-radio-button>
      </el-radio-group>

      <el-radio-group
          v-model="eventCondition.operateCode"
          size="small"
          class="radioGroup"
          @change="changeCondition">
        <el-radio-button label="all">所有</el-radio-button>
        <el-radio-button label="pass" :disabled="eventCondition.eventType === 'event_user'">通过</el-radio-button>
        <el-radio-button label="reject" :disabled="eventCondition.eventType === 'event_user'">拒绝</el-radio-button>
        <el-radio-button label="ban" :disabled="eventCondition.eventType === 'event_appoint'">封禁</el-radio-button>
        <el-radio-button label="un_ban" :disabled="eventCondition.eventType === 'event_appoint'">解封</el-radio-button>
        <el-radio-button label="cancel"
                         :disabled="eventCondition.eventType === 'event_user'||eventCondition.eventType === 'event_doctor'||eventCondition.eventType === 'event_article'">
          预约取消
        </el-radio-button>
        <el-radio-button label="update"
                         :disabled="eventCondition.eventType === 'event_user'||eventCondition.eventType === 'event_doctor'||eventCondition.eventType === 'event_article'">
          预约更新
        </el-radio-button>
        <el-radio-button label="reset_pwd"
                         :disabled="eventCondition.eventType === 'event_article'||eventCondition.eventType === 'event_appoint'">
          重置密码
        </el-radio-button>
      </el-radio-group>
    </div>
    <div class="instrument">
      <el-table
          :data="eventData"
          class="record-table"
          :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
          height="calc(100vh - 380px)"
          max-height="calc(100vh - 380px)">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="用户名称：" v-if="props.row.usName">
                <span>{{ props.row.usName }}</span>
              </el-form-item>
              <el-form-item label="用户手机：" v-if="props.row.usMobile">
                <span>{{ props.row.usMobile }}</span>
              </el-form-item>

              <el-form-item label="医生名字：" v-if="props.row.doName">
                <span>{{ props.row.doName }}</span>
              </el-form-item>
              <el-form-item label="医生手机：" v-if="props.row.doMobile">
                <span>{{ props.row.doMobile }}</span>
              </el-form-item>

              <el-form-item label="文章标题："
                            v-if="props.row.aiTitle||props.row.arTitle||props.row.asTitle">
                <span>{{ props.row.aiTitle }}{{ props.row.arTitle }}{{ props.row.asTitle }}</span>
              </el-form-item>
              <el-form-item label="文章类型："
                            v-if="props.row.aiTitle||props.row.arTitle||props.row.asTitle">
                <span>{{ props.row.aiTitle ? '信息' : props.row.arTitle ? '研究' : props.row.asTitle ? '科普' : '' }}</span>
              </el-form-item>
              <el-form-item label="作者名字："
                            v-if="props.row.aidoName||props.row.ardoName||props.row.asdoName">
                <span>{{ props.row.aidoName }}{{ props.row.ardoName }}{{ props.row.asdoName }}</span>
              </el-form-item>
              <el-form-item label="作者手机："
                            v-if="props.row.aidoMobile||props.row.ardoMobile||props.row.asdoMobile">
                <span>{{ props.row.aidoMobile }}{{ props.row.ardoMobile }}{{ props.row.asdoMobile }}</span>
              </el-form-item>

              <el-form-item label="预约预留姓名：" v-if="props.row.maName">
                <span>{{ props.row.maName }}</span>
              </el-form-item>
              <el-form-item label="预约预留手机：" v-if="props.row.maMobile">
                <span>{{ props.row.maMobile }}</span>
              </el-form-item>
              <el-form-item label="预约医生：" v-if="props.row.madoName">
                <span>{{ props.row.madoName }}</span>
              </el-form-item>
              <el-form-item label="预约医生手机：" v-if="props.row.madoMobile">
                <span>{{ props.row.madoMobile }}</span>
              </el-form-item>
              <el-form-item label="预约账号的用户名：" v-if="props.row.mausName">
                <span>{{ props.row.mausName }}</span>
              </el-form-item>
              <el-form-item label="预约账号的用户手机：" v-if="props.row.mausMobile">
                <span>{{ props.row.mausMobile }}</span>
              </el-form-item>
              <el-form-item label="预约日期：" v-if="props.row.appointDate">
                <span>{{ props.row.appointDate }}</span>
              </el-form-item>
              <el-form-item label="预约时间点：" v-if="props.row.appointTimeSlot">
                <span>{{ props.row.appointTimeSlot }}</span>
              </el-form-item>
              <el-form-item label="备注：" v-if="props.row.remark" show-overflow-tooltip>
                <span>{{ props.row.remark }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
            prop="eventType"
            label="类型"
            width="150" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.eventType === 'event_user'">用户</span>
            <span v-if="scope.row.eventType === 'event_doctor'">医生</span>
            <span v-if="scope.row.eventType === 'event_article'">文章</span>
            <span v-if="scope.row.eventType === 'event_appoint'">预约</span>
          </template>
        </el-table-column>
        <el-table-column
            width="150" align="center"
            prop="operateCode"
            label="操作结果">
          <template slot-scope="scope">
            <span v-if="scope.row.operateCode === 'pass'" class="green common">通过</span>
            <span v-if="scope.row.operateCode === 'reject'" class="pink common">拒绝</span>
            <span v-if="scope.row.operateCode === 'ban'" class="pink common">封禁</span>
            <span v-if="scope.row.operateCode === 'un_ban'" class="green common">解封</span>
            <span v-if="scope.row.operateCode === 'cancel'" class="yellow common">取消</span>
            <span v-if="scope.row.operateCode === 'update'" class="yellow common">更新</span>
            <span v-if="scope.row.operateCode === 'reset_pwd'" class="yellow common">重置密码</span>
          </template>
        </el-table-column>
        <el-table-column
            label="对象" align="center" show-overflow-tooltip>
          <template slot-scope="props">
            <span v-if="props.row.usName">{{ props.row.usName }}</span>
            <span v-if="props.row.doName">{{ props.row.doName }}</span>
            <span v-if="props.row.aiTitle">{{ props.row.aiTitle }}</span>
            <span v-if="props.row.arTitle">{{ props.row.arTitle }}</span>
            <span v-if="props.row.asTitle">{{ props.row.asTitle }}</span>
            <span v-if="props.row.appointNo">预约号:{{ props.row.appointNo }}</span>
          </template>
        </el-table-column>
        <el-table-column
            width="150"
            prop="operator" show-overflow-tooltip
            label="操作者" align="center">
          <template slot-scope="props">
            <!--<span v-if="props.row.madoName">{{ props.row.madoName }}</span>-->
            <span>{{ props.row.operator }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="eventDate"
            width="200" align="center"
            label="事件日期">
        </el-table-column>
        <el-table-column
            prop="reason" align="center" show-overflow-tooltip
            label="事件原因">
        </el-table-column>
        <el-table-column
            width="100"
            align="right">
          <template slot-scope="scope">
            <!--<el-button v-if="scope.row.remark" size="mini" type="text" class="btn"-->
            <!--           @click="updateRemark(scope.row)">更新备注-->
            <!--</el-button>-->
            <!--<el-button v-else size="mini" type="text" class="btn"-->
            <!--           @click="updateRemark(scope.row)">-->
            <!--    添加备注-->
            <!--</el-button>-->
            <el-popover
                placement="top-start"
                title="提示"
                width="200"
                :disabled="scope.row.eventType !== 'event_article' || eventCondition.remark === true"
                trigger="click"
                content="要查看文章历史请点击右上角文章历史">
              <el-button
                  @click="toDetail(scope.row)"
                  size="mini"
                  type="text"
                  class="btn"
                  slot="reference">
                详情
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :hide-on-single-page="true"
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import commonjs from "../../../api/common";

export default {
  name: "eventList",
  data() {
    return {
      eventCondition: {
        eventType: this.$route.query.type || 'event_user',//事件类型
        operateCode: 'all',//审核结果
        eventId: '',//事件对象(文章[变为标题]|医生[变为手机+真名]|用户[变为手机+真名]|预约[变为预约号+预约者真名]),搜索内容
        // operator: '',//操作者(文章[管理员]|医生[管理员]|用户[管理员]|预约[医生])
        // eventDate: '',//事件日期
        // reason: '',//事件原因
        remark: false,//事件备注(仅管理员可见)
      },//事件查询条件
      selectEvent: '',//事件类型选择
      page: {
        current: 1,
        size: 10,
        total: 8
      },//分页
      eventData: [
        {
          eventType: 'event_user',//事件类型
          operateCode: 'reset_pwd',//审核结果
          eventId: 'UID20200521005',//事件对象(文章|医生|用户|预约),搜索内容
          operate: 'admin',//操作者
          eventDate: '2020-09-11 16:28:03',//事件日期
          reason: '原因原因',//事件原因
          remark: '备注备注',//事件备注(仅管理员可见)

          fullName: '用户名字',
          mobile: '13712345678',//编号
          title: '文章标题示例',//文章标题
          appointNo: '1324568796',//预约编号
        },
      ],//事件数据
      remark: {
        id: '',
        remark: '',
      },//备注
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 每页多少条
    handleSizeChange(val) {
      this.page.size = val;
    },
    // 当前页  根据标签页分别执行传输
    handleCurrentChange(val) {
      this.page.current = val;
      this.getData();
    },
    //获得数据
    getData() {
      let that = this;
      this.$ajax
          .post(commonjs.api.event.edit.page.replace("{current}/{size}", this.page.current + "/" + this.page.size), this.eventCondition)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.eventData = res.data.rows;
              that.page.total = res.data.total;
            } else {
              that.$message.error(res.data.message);
            }
          });
    },
    //改变条件
    changeCondition() {
      this.page.current = 1;
      this.getData();
    },
    //备注
    updateRemark(item) {
      let that = this;
      this.remark.id = item.id;
      this.$prompt('请填写备注', '备注', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        inputValue: item.remark,
      }).then(({value}) => {
        this.remark.remark = value;
        this.$ajax.post(commonjs.api.event.edit.remark, this.remark).then(function (res) {
          if (res.data.status === 'success') {
            that.$message.success('操作成功')
            item.remark = value;
          } else {
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消备注'
        });
      })
    },
    toDetail(item) {
      if (item.eventType === 'event_user') {
        this.$router.push({path: '../user/detail/' + item.eventId})
      } else if (item.eventType === 'event_doctor') {
        this.$router.push({path: '../doctor/detail/' + item.eventId})
      } else if (item.eventType === 'event_appoint') {
        this.$router.push({path: '../appoint/detail/' + item.eventId})
      } else if (item.eventType === 'event_article' && this.eventCondition.remark === true) {
        this.$router.push({path: 'historyArticle/' + item.id})
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

.radioGroup {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>